/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import {Component, ViewEncapsulation} from '@angular/core';
import { FcResponsiveAgDialogComponent } from './fc-responsive-ag-dialog.component';

/**
 * Simple message dialog component.
 */
@Component({
    selector: 'fc-responsive-ag-dialog-simple-message',
    templateUrl: './fc-responsive-ag-dialog-simple-message.component.html',
    styleUrls: ['./fc-responsive-ag-dialog-simple-message.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FcResponsiveAgDialogSimpleMessageComponent 
    extends FcResponsiveAgDialogComponent {
    /**
     * Dialog icon class.
     */
    iconClass: string = '';
    
    /**
     * Dialog component header string.
     */
    title: string = '';

    /**
     * Dialog component body string.
     */
    message: string = '';

    /**
     * Dialog component button OK label.
     */
    btnOkLabel: string = 'OK';
    
    /**
     * Dialog component button cancel label.
     */
    btnCancelLabel: string = 'Cancel';

    /**
     * Dialog component button Cancel status.
     */
    showBtnCancel: boolean = false;
    
    /**
     * Dialog component button OK status.
     */
    showBtnOk: boolean = true;

    /**
     * Default constructor.
     */
    constructor() {
        super();
    }
}